import { render, staticRenderFns } from "./WorkRegimeHistoryButton.vue?vue&type=template&id=bd468da4&scoped=true"
import script from "./WorkRegimeHistoryButton.vue?vue&type=script&lang=js"
export * from "./WorkRegimeHistoryButton.vue?vue&type=script&lang=js"
import style0 from "./WorkRegimeHistoryButton.vue?vue&type=style&index=0&id=bd468da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd468da4",
  null
  
)

export default component.exports